import { render, staticRenderFns } from "./receive_alarm.vue?vue&type=template&id=7f491778&scoped=true&"
import script from "./receive_alarm.vue?vue&type=script&lang=js&"
export * from "./receive_alarm.vue?vue&type=script&lang=js&"
import style0 from "./receive_alarm.vue?vue&type=style&index=0&id=7f491778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f491778",
  null
  
)

export default component.exports